import { useEffect, useState } from 'react'
import axios from "axios"

interface apiParams {
   path: string,
   method: string,
   body?: object
}

interface stateReq {
   loading: boolean,
   error: string | boolean,
   data: any,
}

const baseUrl = ""

export const apiReq = async ({ method, path, body }: apiParams) => {
   console.log("api", method, path, body);

   try {
      const { data: res } = await axios({
         url: baseUrl + path,
         method,
         data: body
      })

      if (res.error) throw res.error

      // console.log("response \n ", res);
      return res

   } catch (error: any) {
      // console.log("error \n ", error.message || error);
      throw error
   }
}

export const useApi = (params: apiParams) => {
   const [state, setState] = useState<stateReq>({ loading: true, error: false, data: false })

   const createApi = (): void => {
      apiReq(params)
         .then(data => setState({ ...state, data, loading: false }))
         .catch(err => setState({ ...state, error: err.message, loading: false }))
   }

   useEffect(createApi, [])

   return { ...state, createApi }
}
